export default function upperFirst(str) {
   // eslint-disable-next-line no-magic-numbers
   return str.substring(0, 1).toUpperCase() + str.substring(1);
}
